import { HasuraQueries } from "@/api/hasura/queries"
import { GetDcaConfigurationQuery } from "@/api/hasura/generated/graphql"
import { QueryResult } from "@/api/utils/types"
import { useQuery } from "@/api/utils/useQuery"
import { DcaConfiguration } from "@/models/dcaConfiguration/dcaConfiguration"
import { DcaConfigurationParser } from "@/models/dcaConfiguration/dcaConfiguration.parser"

interface IDcaConfigurationService {
  getConfiguration: () => QueryResult<DcaConfiguration[]>
}

class DcaConfigurationServiceClass implements IDcaConfigurationService {
  getConfiguration() {
    return useQuery({
      ...HasuraQueries.dcaConfiguration.getConfiguration,
      placeholderData: [],
      useRawResponse: true,
      parserFn: (data: GetDcaConfigurationQuery) =>
        data?.tickets_dca_configuration_v2.map((config) =>
          DcaConfigurationParser.toDomain(config),
        ) ?? [],
    })
  }
}

export const DcaConfigurationService = new DcaConfigurationServiceClass()
